import React  from "react";

const ClientCard = ({ client, styles }) => {
    const avatar = client?.profile_picture_url || '/img/profile_default_image.png';
    return (
        <div className="card" style={styles.card}>
            <div className="card-header" style={styles.card_header}>
                <h6 className="card-title" style={styles.card_title}>Solicitante</h6>
            </div>
            <div className="card-body">
               <div style={{display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px'}}>
                   <img src={avatar} alt={client?.name} style={{width: 48, height: 48, borderRadius: '50%', objectFit: 'cover'}} />
                   <strong>{client?.name}</strong>
               </div>
               <table className="table table-bordered table-striped">
                     <tbody>
                            <tr>
                                <th>Nome</th>
                                <th>{client?.name}</th>
                            </tr>
                            <tr>
                                <th>E-mail</th>
                                <th>
                                    <i className="fa fa-envelope"></i> &nbsp;
                                    {client?.email}
                                </th>
                            </tr>
                            <tr>
                                <th>Empresa</th>
                                <th>{client?.empresa?.name}</th>
                            </tr>
                     </tbody>

               </table>
            </div>
        </div>
    );
}

export default ClientCard;
